import React from "react";
import {
  FlatActionList,
  FlatActionListItem,
  Page,
} from "@towersystems/roam-common-native";
import { useFormContext } from "react-hook-form";
import { Feather } from "@expo/vector-icons";
import { StackScreenProps } from "@react-navigation/stack";
import { useTranslation } from "react-i18next";
import {
  PaymentMethodFormValues,
  RoundingAlgorithm,
} from "../PaymentMethodForm/types";

const options = [
  {
    label: "Round midpoint down",
    value: RoundingAlgorithm.ROUND_MIDPOINT_DOWN,
    description: "e.g for 0.10 rounding, 1.05 will round to 1.00",
  },
  {
    label: "Round midpoint up",
    value: RoundingAlgorithm.ROUND_MIDPOINT_UP,
    description: "e.g for 0.10 rounding, 1.05 will round to 1.10",
  },
];

export type SelectRoundingAlgorithmScreenProps = StackScreenProps<
  any,
  "SelectRoundingAlgorithmScreen"
>;

export const SelectRoundingAlgorithmScreen = ({
  navigation,
}: SelectRoundingAlgorithmScreenProps) => {
  const { t } = useTranslation("settings");

  const { watch, setValue } = useFormContext<PaymentMethodFormValues>();

  const watchedRoundingAlgorithm = watch("rounding.roundingAlgorithm");

  const items: FlatActionListItem[] = React.useMemo(() => {
    return options.map((option) => ({
      id: option.value,
      key: option.value,
      title: option.label,
      subTitle: option.description,
      icon: <Feather name="check" size={24} color="black" />,
      onPress: () => {
        setValue("rounding.roundingAlgorithm", option.value, {
          shouldValidate: true,
          shouldDirty: true,
        });
        navigation.goBack();
      },
      selected: watchedRoundingAlgorithm === option.value,
    }));
  }, [watchedRoundingAlgorithm]);

  return (
    <Page title={t("modal_select_rounding_algorithm_title")}>
      <FlatActionList items={items} />
    </Page>
  );
};
